import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f3e95c1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filter-dropdown" }
const _hoisted_2 = { class: "flex items-center gap-2" }
const _hoisted_3 = { class: "text-sm font-semibold text-neutral-700 whitespace-nowrap" }
const _hoisted_4 = {
  key: 1,
  class: "bg-blue-100 text-blue-600 text-xs font-bold px-2 py-0.5 rounded-full ml-1"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-chevron-down text-neutral-500 text-xs" }, null, -1))
const _hoisted_6 = { class: "w-60" }
const _hoisted_7 = { class: "font-bold text-neutral-800 mb-3 text-sm" }
const _hoisted_8 = {
  key: 0,
  class: "text-xs text-neutral-500 italic py-2"
}
const _hoisted_9 = ["for"]
const _hoisted_10 = {
  key: 1,
  class: "text-xs text-neutral-400 text-center py-1"
}
const _hoisted_11 = { class: "flex items-center justify-end gap-2 pt-3 border-t border-neutral-100" }

import { ref, PropType } from 'vue'
import OverlayPanel from 'primevue/overlaypanel'
import Button from 'primevue/button'
import Checkbox from 'primevue/checkbox'


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterDropdown',
  props: {
  label: {
    type: String,
    required: true
  },
  title: {
    type: String,
    required: true
  },
  options: {
    type: Array as PropType<Array<{ value: string; label: string }>>,
    default: () => []
  },
  modelValue: {
    type: Array as PropType<string[]>,
    default: () => []
  },
  icon: {
    type: String,
    default: ''
  },
  loading: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:modelValue', 'apply', 'reset', 'open', 'scroll-end'],
  setup(__props, { emit }) {

const props = __props





const onScrollOptions = (e: Event) => {
  const target = e.target as HTMLElement
  if (target.scrollTop + target.clientHeight >= target.scrollHeight - 15) {
    emit('scroll-end')
  }
}

const op = ref()
const internalValue = ref<string[]>([])

const togglePanel = (event: Event) => {
  if (!op.value.visible) {
    internalValue.value = [...props.modelValue]
    emit('open')
  }
  op.value.toggle(event)
}

const applyFilter = () => {
  emit('update:modelValue', [...internalValue.value])
  emit('apply')
  op.value.hide()
}

const resetFilter = () => {
  internalValue.value = []
  emit('update:modelValue', [])
  emit('reset')
  op.value.hide()
}

const onHide = () => {
  internalValue.value = [...props.modelValue]
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "filter-dropdown-btn border border-neutral-300 rounded-lg px-4 py-2 flex items-center justify-between bg-white hover:bg-neutral-50 transition-colors w-full md:w-48",
      type: "button",
      onClick: togglePanel
    }, [
      _createElementVNode("div", _hoisted_2, [
        (__props.icon)
          ? (_openBlock(), _createElementBlock("i", {
              key: 0,
              class: _normalizeClass(['pi', __props.icon, 'text-neutral-500 text-sm'])
            }, null, 2))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_3, _toDisplayString(__props.label), 1),
        (__props.modelValue && __props.modelValue.length > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.modelValue.length), 1))
          : _createCommentVNode("", true)
      ]),
      _hoisted_5
    ]),
    _createVNode(_unref(OverlayPanel), {
      ref_key: "op",
      ref: op,
      showCloseIcon: false,
      onHide: onHide
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(__props.title), 1),
          _createElementVNode("div", {
            class: "flex flex-col max-h-60 overflow-y-auto mb-4 pr-1",
            onScroll: onScrollOptions
          }, [
            (__props.options.length === 0 && !__props.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Tidak ada data "))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.value,
                class: "flex items-center mb-2.5 last:mb-0"
              }, [
                _createVNode(_unref(Checkbox), {
                  modelValue: internalValue.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalValue).value = $event)),
                  inputId: `filter_opt_${item.value}`,
                  name: "filter_opt",
                  value: item.value
                }, null, 8, ["modelValue", "inputId", "value"]),
                _createElementVNode("label", {
                  for: `filter_opt_${item.value}`,
                  class: "ml-2.5 text-sm text-neutral-700 cursor-pointer w-full select-none"
                }, _toDisplayString(item.label), 9, _hoisted_9)
              ]))
            }), 128)),
            (__props.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Memuat... "))
              : _createCommentVNode("", true)
          ], 32),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_unref(Button), {
              label: "Reset",
              class: "btn-dropdown-action btn-reset",
              onClick: resetFilter
            }),
            _createVNode(_unref(Button), {
              label: "Terapkan",
              class: "btn-dropdown-action btn-apply",
              onClick: applyFilter
            })
          ])
        ])
      ]),
      _: 1
    }, 512)
  ]))
}
}

})